enum TimeAvailable {
  ThirtyMinutes = '30OrLess',
  FourtyFiveMinutes = '45',
  SixtyMinutes = '60',
  NinetyMinutes = '90',
}

const timeAvailableQuestion = {
  name: "timeAvailable",
  title: `<span class="highlight">{name}</span>, what is your ideal workout length?`,
  description: `More isn’t always better. Choose what you’ll be most consistent with.`,
  descriptionLocation: "underTitle",
  type: "radiogroup",
  choices: [
    {
      value: TimeAvailable.ThirtyMinutes,
      text: "30 minutes",
      enableIf: "{numberWorkouts} != '2' and {numberWorkouts} != 'As many as possible'",
    },

    {
      value: TimeAvailable.SixtyMinutes,
      text: "60 minutes",
    },
  ],
  isRequired: true,
};

export { TimeAvailable, timeAvailableQuestion };
